'use strict'

module.exports = bail

function bail(err) {
  if (err) {
    throw err
  }
}



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/bail/index.js
// module id = 285
// module chunks = 0 3